import { TCommonResponse } from '@/common/types';
import ApiService from '@/services/api';
import message from '@/utils/message';
import axios from 'axios';

// TYPES

export type TGetListCountryParams = unknown;

export type TGetListCountryResponse = TCommonResponse;

export const getListCountry = async (): Promise<TGetListCountryResponse> => {
  try {
    const response = await ApiService.get(`/companies/api/getListCountries/`);
    return response?.data; // Return the data from the response
  } catch (error) {
    message.error(error.response.data.status_message);
    throw error.response; // Rethrow the error to handle it in your saga
  }
};
